import * as angular from "angular";
import {IHttpService, ILogService} from "angular";
import "angularfire";
import "angular-feature-flags";
import {FirebaseService} from "./firebase.service";

export const FirebaseModule = angular
    .module("app.shared.firebase", ["feature-flags", "firebase"])

    .service("firebaseService", FirebaseService)

    .run(($log: ILogService, firebase: any, firebaseService: FirebaseService, $http: IHttpService, featureFlags: any) => {
        $log.debug("app.shared.firebase run()");
        featureFlags.set($http.get("/api/config/features"));
        firebaseService.getConfig()
            .then((firebaseConfig) => {
                $log.debug("firebaseConfig: ", firebaseConfig);
                firebase.initializeApp(firebaseConfig);
                $log.debug("firebase.initializeApp() done.");
            });
    })

    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/firebase/firebase.module.ts